import NotebookPanes from './NotebookPanes'

// Body for a notebook grid window. Renders the editor|PDF split once the page
// is resolved, a loading placeholder while it hydrates, or a prompt when the
// window is empty.
function NotebookWindowBody({
  page,
  loading,
  panes,
  onPanesChange,
  onSaved,
  onCreatePage,
  onOpenPage,
  onDeletePage,
  pageTitle,
  pagePath,
  onLocate,
}) {
  if (page) {
    return (
      <NotebookPanes
        page={page}
        panes={panes}
        onPanesChange={onPanesChange}
        onSaved={onSaved}
        onCreatePage={onCreatePage}
        onOpenPage={onOpenPage}
        onDeletePage={onDeletePage}
        pageTitle={pageTitle}
        pagePath={pagePath}
        onLocate={onLocate}
      />
    )
  }
  if (loading) {
    return <div className="display-empty">Loading…</div>
  }
  return <div className="display-empty">Select a note from the list.</div>
}

export default NotebookWindowBody
